<template>
  <v-row no-gutters class="justify-start pt-2">
    <v-col cols="auto">
      <v-row no-gutters>
        <v-col cols="auto">
          <v-badge overlap :content="badgeValue" :value="hasBadge" color="error" :offset-x="28">
            <base-button
              v-bind="{ ...$props, ...$attrs }"
              :color="computedIsActive ? colorActive : colorInActive"
              :button-style="`background-color: ${backgroundColor}`"
              toggleable
              v-on="$listeners"
              @click="toggle"
            />
          </v-badge>
        </v-col>
      </v-row>
      <v-row no-gutters v-if="subheaderTranslationPath">
        <v-col>
          <template v-if="Array.isArray(subheaderTranslationPath)">
            <v-row no-gutters v-for="(subheader, idx) of subheaderTranslationPath" :key="idx" style="height: 14px">
              <v-col cols="auto" style="height: inherit">
                <span class="font-italic font-weight-light button-toggleable-subheader">{{ $i18n.t(subheader) }}</span>
              </v-col>
            </v-row>
          </template>
          <template v-else>
            <v-col cols="auto">
              <italic-subheader :translation-path="subheaderTranslationPath"> </italic-subheader>
            </v-col>
          </template>
        </v-col>
      </v-row>
    </v-col>
  </v-row>
</template>

<script>
import ItalicSubheader from '@/components/ItalicSubheader';
import { asArray, asString } from 'ol/color';

export default {
  name: 'BaseButtonToggleable',
  components: {
    ItalicSubheader,
  },
  props: {
    colorActive: {
      type: String,
      default: '#2196F3',
    },
    colorInActive: {
      type: String,
      default: '#7d818c',
    },
    isActive: {
      type: Boolean,
      default: false,
    },
    subheaderTranslationPath: {
      type: [String, Array],
    },
    hasBadge: {
      type: Boolean,
      default: false,
    },
    badgeValue: {
      type: [String, Number],
    },
  },
  computed: {
    backgroundColor() {
      const color = this.computedIsActive ? this.colorActive : this.colorInActive;
      const colorRgba = color.includes('#') ? this.hexToRgba(color, 0.1) : color;
      return colorRgba;
    },
    computedIsActive: {
      get() {
        return this.isActive;
      },
      set(nV) {
        this.$emit('update:isActive', nV);
      },
    },
  },
  methods: {
    hexToRgba(hex, opacity) {
      const [r, g, b] = Array.from(asArray(hex));
      return asString([r, g, b, opacity]);
    },
    toggle() {
      this.computedIsActive = !this.computedIsActive;
      this.$emit('change', !this.computedIsActive);
    },
  },
};
</script>
<style lang="scss" scoped>
.button-toggleable-subheader {
  font-size: 11px;
  color: rgba(0, 0, 0, 0.59);
}
</style>
